import { observer } from 'mobx-react-lite'
import { Filters } from 'widgets/inbox/ConversationList/ui/Filters/Filters'
import { useSearchParams } from 'react-router-dom'
import { NewConversationCard } from 'widgets/inbox/ConversationList/ui/NewConversationCard/NewConversationCard'

export const ConversationListUi = observer(() => {
  const [params] = useSearchParams()
  return (
    <>
      <Filters />
      {params.has('new') && <NewConversationCard />}
    </>
  )
})
